import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORM_URL } from 'app/@common/constants'

export default function SelectCompset({...props}) {

    const myProps = {
        urlAjax: FORM_URL.COMPETITION.COMPSET,
        placeholder: i18n.t('common:filters.allCompsets'),
        icon: { icon: 'list' },
        isMulti: true,
        isClearable: true, 
        extraParams: props.idUser && {
            id_user: props.idUser
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}